'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002499 from "./presto.types$$anon$99.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$98() {
  this.c4A = null;
  this.c4s = null;
  this.c4t = false;
  this.c4B = null;
  this.c4C = false;
  this.c4F = null;
  this.c4y = null;
  this.c4z = false;
  this.c4u = null;
  this.c4v = false;
  this.c4w = null;
  this.c4x = false;
  this.c4D = false;
  this.c4E = false;
  this.c4A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c4F = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$98 as $c_Lpresto_types$$anon$98 };
$p = $c_Lpresto_types$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$98;
/** @constructor */
function $h_Lpresto_types$$anon$98() {
}
export { $h_Lpresto_types$$anon$98 as $h_Lpresto_types$$anon$98 };
$h_Lpresto_types$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.c4A;
});
$p.M = (function() {
  if ((!this.c4t)) {
    this.c4s = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c4t = true;
  }
  return this.c4s;
});
$p.O = (function() {
  if ((!this.c4C)) {
    this.c4B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c4C = true;
  }
  return this.c4B;
});
$p.D = (function() {
  return this.c4F;
});
$p.t = (function() {
  if ((!this.c4z)) {
    this.c4y = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c4z = true;
  }
  return this.c4y;
});
$p.N = (function() {
  if ((!this.c4v)) {
    this.c4u = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c4v = true;
  }
  return this.c4u;
});
$p.Q = (function() {
  if ((!this.c4x)) {
    this.c4w = new $j_presto$002etypes$0024$0024anon$002499.$c_Lpresto_types$$anon$99();
    this.c4x = true;
  }
  return this.c4w;
});
$p.v = (function() {
  if ((!this.c4E)) {
    this.c4D = false;
    this.c4E = true;
  }
  return this.c4D;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee140) => ((p) => \u03b4scrutinee140.csi(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$98, "presto.types$$anon$98", ({
  Yu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$98 as $d_Lpresto_types$$anon$98 };
//# sourceMappingURL=presto.types$$anon$98.js.map
